import {
  useMfaServiceMfaConfigsCreate,
  useMfaServiceMfaConfigsPartialUpdate,
  useMfaServiceMfaUsersListKey
} from '@organization/api/queries'
import {
  MFAConfigCreate,
  MFAUser,
  PatchedMFAConfigUpdate
} from '@organization/api/requests'
import { showApiErrors } from '@shared/utils'
import { useQueryClient } from '@tanstack/react-query'
import { App, Switch, SwitchProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  data: MFAUser
  updateBody?: (checked: boolean) => PatchedMFAConfigUpdate
} & SwitchProps

export const ConfigMFASwitchProperty = ({
  data,
  updateBody,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { message } = App.useApp()

  const onSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: [useMfaServiceMfaUsersListKey]
    })
    message.success(t('edited_successfully'))
  }

  const { mutate: createMutate, isPending: isCreatePending } =
    useMfaServiceMfaConfigsCreate({
      onSuccess,
      onError: (error) => showApiErrors(error)
    })

  const { mutate: updateMutate, isPending: isUpdatePending } =
    useMfaServiceMfaConfigsPartialUpdate({
      onSuccess,
      onError: (error) => showApiErrors(error)
    })

  const onChange = (checked: boolean) => {
    if (data.mfa_config?.id)
      updateMutate({
        id: data.mfa_config.id,
        requestBody: {
          ...data.mfa_config,
          ...updateBody?.(checked)
        }
      })
    else
      createMutate({
        requestBody: {
          sso_id: data.id,
          enabled: checked
        } as MFAConfigCreate
      })
  }

  return (
    <Switch
      loading={isUpdatePending || isCreatePending}
      onChange={onChange}
      {...props}
    />
  )
}
